import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, GitMerge } from 'lucide-react';
import { Button } from './Button';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Product',
    path: '/product'
  }, {
    name: 'Why not HubSpot workflows?',
    path: '/why-not-hubspot-workflows'
  }, {
    name: 'Use Cases',
    path: '/use-cases'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <nav className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/80 backdrop-blur-md" data-id="element-191">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-192">
        <div className="flex h-16 items-center justify-between" data-id="element-193">
          <div className="flex items-center" data-id="element-194">
            <Link to="/" className="flex items-center gap-2" data-id="element-195">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-600 text-white" data-id="element-196">
                <GitMerge size={20} data-id="element-197" />
              </div>
              <span className="text-xl font-bold tracking-tight text-slate-900" data-id="element-198">
                DemandPath
              </span>
            </Link>
          </div>

          <div className="hidden md:block" data-id="element-199">
            <div className="ml-10 flex items-baseline space-x-8" data-id="element-200">
              {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors ${isActive(link.path) ? 'text-brand-600' : 'text-slate-600 hover:text-slate-900'}`} data-id="element-201">
                  {link.name}
                </Link>)}
            </div>
          </div>

          <div className="hidden md:flex items-center gap-4" data-id="element-202">
            <Link to="/book-a-demo" className="text-sm font-medium text-slate-600 hover:text-slate-900" data-id="element-203">
              Log in
            </Link>
            <Button href="/book-a-demo" variant="primary" size="sm" data-id="element-204">
              Book a demo
            </Button>
          </div>

          <div className="-mr-2 flex md:hidden" data-id="element-205">
            <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center justify-center rounded-md p-2 text-slate-400 hover:bg-slate-100 hover:text-slate-500 focus:outline-none" data-id="element-206">
              <span className="sr-only" data-id="element-207">Open main menu</span>
              {isOpen ? <X className="block h-6 w-6" aria-hidden="true" data-id="element-208" /> : <Menu className="block h-6 w-6" aria-hidden="true" data-id="element-209" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && <div className="md:hidden border-t border-slate-200 bg-white" data-id="element-210">
          <div className="space-y-1 px-2 pb-3 pt-2 sm:px-3" data-id="element-211">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`block rounded-md px-3 py-2 text-base font-medium ${isActive(link.path) ? 'bg-brand-50 text-brand-600' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} onClick={() => setIsOpen(false)} data-id="element-212">
                {link.name}
              </Link>)}
            <div className="mt-4 px-3" data-id="element-213">
              <Button href="/book-a-demo" variant="primary" className="w-full justify-center" data-id="element-214">
                Book a demo
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}